<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <div
        class="wizard wizard-1"
        id="kt_wizard_v1"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!-- J'ai découpé le Wizard/Stepper afin de pouvoir réutiliser ses étapes dans la modification par exemple -->
        <WizardNav></WizardNav>
        <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
          <div class="col-xl-12">
            <!--begin: Wizard Form-->
            <v-form ref="form" class="form" id="kt_form">
              <!-- On utilise un custom v-model, pour facilement récupérer les données
              des enfants dans ce composant sans faire énormément de $emit -->
              <FormVideoStep1 v-model="formData"></FormVideoStep1>
              <FormVideoStep2 v-model="formData" mode="add"></FormVideoStep2>
              <FormVideoStep3 v-model="formData"></FormVideoStep3>
              <!-- On attends ici que le composant nous envoie un evenement appelé "submit".
              Quand ce sera le cas, on appelera notre method submit ici.
              Ainsi, on peut utiliser le même stepper pour la modification et l'ajout
              Voir $emit dans la documentation-->
              <WizardActions @submit="submit"></WizardActions>
            </v-form>
          </div>
          <div v-if="mode === 'add'" class="d-flex justify-content-around col-8">
            <!-- button dialog Droits utilisateurs-->
            <div>
              <v-dialog v-model="dialog" width="600px" max-height="400px">
                <template v-slot:activator="{ on }">
                  <!-- <v-btn color="primary" dark v-on="on">({{userRights.length}}) Droits utilisateurs</v-btn> -->
                  <v-btn color="primary" dark v-on="on">Droits utilisateurs</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline pl-2">Nom des droits utilisateurs</span>
                  </v-card-title>
                  <v-card-text>
                    <!-- Display Client -->
                    <div class="py-5">
                      <v-simple-table fixed-header dense>
                        <tr class="py-0" v-for="userRight in userRights" :key="userRight.id" >
                          <td style="font-size:13px">{{ userRight.name }}</td>
                        </tr>
                      </v-simple-table>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false">Fermer</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

            <!-- button dialog Utilisateurs-->
            <div>
              <v-dialog v-model="dialog2" width="600px" max-height="400px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark v-on="on">Utilisateurs</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <div class="headline pl-2">Utilisateurs (Prénom Nom Client)</div>
                  </v-card-title>
                  <v-card-text>
                    <!-- Display utilisateur -->
                    <div class="py-5">
                      <v-simple-table fixed-header dense>

                          <div class="py-0" v-for="user in users" :key="user.id">
                            <span style="font-size:13px"> {{ user.firstname }} {{ user.lastname }} </span>
                            <span v-if="user.client" class="py-0">
                              <b><span style="font-size: 13px"> {{ user.client.name }}</span></b>
                            </span>
                          </div>

                      </v-simple-table>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog2 = false">Fermer</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- Dialog qui affiche la progress circular.
    Ne s'affiche que si loading = true -->
    <v-dialog v-model="loading" fullscreen full-width>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="pink">
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import FormVideoStep1 from "@/components/admin/video/forms/wizard/formVideoStep1";
import FormVideoStep2 from "@/components/admin/video/forms/wizard/formVideoStep2";
import FormVideoStep3 from "@/components/admin/video/forms/wizard/formVideoStep3";
import WizardNav from "@/components/admin/video/forms/wizard/wizardNav";
import WizardActions from "@/components/wizard/wizardActions";

export default {
  name: "creerVideo",
  components: {
    FormVideoStep1,
    FormVideoStep2,
    FormVideoStep3,
    WizardActions,
    WizardNav,
  },
  data: () => ({
    loading: false, //Progress circular
    formData: {
      //Données que l'on va envoyer dans nos requêtes (soit pour l'ajout, soit la modif)
      videoFile: null,
      posterFile: null,
      title: "",
      titleEN: "",
      description: "",
      descriptionEN: "",
      isVisible: true,
      client: "",
      partner: null,
      views : 0,
      keywords: {
        visibleEN: [],
        visibleFR: [],
        invisibleEN: [],
        invisibleFR: [],
      },
      theme: [],
    },
    users: [],
    userRights: [],
    themes: [],
    clients: [],
  }),
  watch: {
    videoForWatcher: {
      deep: true,
      handler(newVideo, oldVideo) {
        const newClientId = newVideo.client ? newVideo.client['@id'] : null;
        const oldClientId = oldVideo.client ? oldVideo.client['@id'] : null;
        const newThemeId = newVideo.theme && newVideo.theme[0] ? newVideo.theme[0]['@id'] : null;
        const oldThemeId = oldVideo.theme && oldVideo.theme[0] ? oldVideo.theme[0]['@id'] : null;
        if (oldVideo === null || newClientId !== oldClientId || newThemeId !== oldThemeId) {
          this.refreshUsers();
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionContenus" },
      { title: "Gestion des contenus", route: "gestionContenus" },
      { title: "Créer une vidéo" },
    ]);
        // Initialize form wizard
    const wizard = new KTWizard("kt_wizard_v1", {
      startStep: 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });

    // Validation before going to next page
    wizard.on("beforeNext", function(wizardObj) {
      if (!this.$refs.form.validate()) {
        wizardObj.stop();
      }
    });

    // Change event
    wizard.on("change", function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
        // TODO: Refactoring: Supprimer cette appel API qui semble ne pas être utile ?
    Api.get("themes").then((themes) => {
      this.themes = themes.data["hydra:member"];
    });

    const videoId = this.$route.params.id;
    const videoData = this.$route.params.video;
    const self = this;
    if (videoData) {
      this.populateVideoForm(videoData);
    } else {
      Api.get('videos', videoId, { headers: { 'Accept-Language': 'fr_FR' } }).then((video) => {
        self.populateVideoForm(video.data);
      });
    }
    this.refreshUsers();
  },
  methods: {
    // On utilise les fonction asynchrones
    // Au submit, on attends premièrement que les tags soient tous crées
    // TODO: Message d'erreur en cas de problème. Ne pas continuer la création de vidéo. (try catch)
    submit: async function() {
      if (!this.$refs.form.validate() || !this.formData.theme.length) {

         Swal.fire({
            //Swal = Sweet Alert
            title: "Impossible de créer la vidéo",
            text: "Vérifier les champs du formulaire avant de pouvoir créer la vidéo. Certaines informations sont obligatoires et signalées par un astérisque (*)",
            icon: "warning",
            confirmButtonClass: "btn btn-secondary",
          });
      } else {
        const keywords = await Promise.all([
          ...this.formData.keywords.visibleFR.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "FR",
                  isVisible: true,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.formData.keywords.visibleEN.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "EN",
                  isVisible: true,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.formData.keywords.invisibleFR.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "FR",
                  isVisible: false,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
          ...this.formData.keywords.invisibleEN.map((k) =>
            typeof k === "string"
              ? Api.post("keywords", {
                  name: k,
                  lang: "EN",
                  isVisible: false,
                }).then((res) => res.data)
              : Promise.resolve(k)
          ),
        ]);

        let response;
        try {
          //On ouvre la progress circular
          this.loading = true;
          //On envoie les informations concernant la vidéo en JSON, en premier.
          response = await Api.post("videos", {
            title: this.formData.title,
            description: this.formData.description,
            keywords: keywords.map((k) => k["@id"]), //Boucle sur tout les keywords pour n'envoyer que les @id pour Api platform qui ne comprends que les IRIs et pas l'objet entier
            theme: this.formData.theme[0]["@id"],
            isVisible: this.formData.isVisible,
            views : Number(this.formData.views) ? Number(this.formData.views) : 0,
            client: this.formData.client["@id"],
            partner: this.formData.partner ? this.formData.partner["@id"] : null,
            realViews: 0,
          }, { headers: { 'Accept-Language': 'fr_FR' } });
          await Api.patch('videos', response.data.id, {
            title: this.formData.titleEN,
            description: this.formData.descriptionEN
          }, { headers: { 'Accept-Language': 'en_GB' } });
          this.loading = false;
        } catch (error) {
          //Dans le cas où la première requête à échoué, on ne va pas plus loin
          Swal.fire({
            title: "",
            text: "Une erreur est survenue lors de la création de la vidéo",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
          this.loading = false;
          return;
        }

        //On construit le formData pour y mettre les fichiers, qui seront envoyés seulement si la requête
        //Ci-dessus à fonctionné.
        // Pour rappel, on utilise FormData car on ne peut pas envoyer de media en JSON. (c'est du binaire)
        var bodyFormData = new FormData();
        bodyFormData.append("poster", this.formData.posterFile);
        bodyFormData.append("video", this.formData.videoFile);
        try {
          //Dans l'API, on a crée une route spécialement pour pouvoir recevoir du formdata avec des fichiers
          //et pouvoir les traiter. (Voir documentation API Platform FormData)
          //On va donc modifier la vidéo préalablement créee par la requêté ci-dessus, pour y rajouter les fichiers
          //On doit séparer la requête en deux, car le FormData gère mal les collections d'objets
          await Api.post(`videos/${response.data.id}/media`, bodyFormData);
          this.loading = false;
          //On stop le progress circular
          this.$router.push({ name: "gestionContenus", query: {
                  selected: 'tab-videos',
                }, });
          //router.push redirection

          //Une fois que les 2 requêtes ont réussis
          Swal.fire({
            //Swal = Sweet Alert
            title: "",
            text: "La vidéo a été ajoutée.",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
          });
        } catch (error) {
          //En cas d'erreur, on ferme le progress circular
          this.loading = false;
          //Dans le cas où la première requête à réussi, mais que nous n'avons pas réussi à rajouter les fichiers avec la 2eme requête
          Swal.fire({
            title: "",
            text:
              "La vidéo a bien été créée, cependant une erreur est survenue lors de l'upload du/des fichiers. Vous pouvez modifier la vidéo pour les rajouter",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
        }
      }
    },
    refreshUsers() {
      if (this.video) {
        Api.query("user_rights", { params: { themes: this.video.theme[0].id } })
            .then(response => {
              const userRights = response.data["hydra:member"];
              this.userRights = userRights;
              //if (typeof this.video.client === 'undefined' || !this.video.client) {
              this.users = [...new Set(userRights.map(ur => ur.users).flat())];
              //}
              if(this.video.client){
                this.users = this.users.filter((u)=>u.client['@id'] === this.video.client['@id'])
              }
            })
            .catch(err => console.log(err))
            .finally(() => this.isLoading = false);
      }
    }
  },
};
</script>

<style lang="scss">
  @import "@/assets/sass/pages/wizard/wizard-1.scss";
</style>
